

<!-- HERO SECTION - Solo imagen de fondo -->
<section class="hero-section-bg-v5">
    <!-- Info Message comentado por el momento -->
    <!--
    <div class="info-message-v1">
        <div class="quote-v1">
            <p>Juntos lo hacemos posible.</p>
        </div>
        <div class="author-v1">
            <span class="name">Carmen Lilia Canturosas</span>
            <span class="title">Presidenta Municipal</span>
        </div>
    </div>
    -->
</section>

<!-- Tarjeta Presidenta -->
<!-- Tarjeta Presidenta -->
<section class="president-section-v8">
    <div class="president-card-v8">
        <!--https://nld.gob.mx/assets/img/carmen.jpg-->
        <img src="https://nld.gob.mx/assets/img/carmen22.png" alt="Carmen Lilia Canturosas"
            class="president-photo-v8">

        <div class="president-content-v8">
            <a href="/mensaje" class="president-name-link">
                <h2>Carmen Lilia Canturosas Villarreal</h2>
            </a>
            <p>Presidenta Municipal</p>
        </div>

        <a routerLink="/mensaje" class="btn-cabildo-v8">
            Mensaje de la Presidenta Municipal
            <i class="bi bi-arrow-right"></i>
        </a>
    </div>
</section>
<section class="banner-section banner-section-top">
    <div class="banner-container">
        <a [href]="bannerTop.url" [target]="bannerTop.target || '_blank'" class="banner-link">
            <img [src]="bannerTop.imagen" [alt]="bannerTop.alt" class="banner-image">
        </a>
    </div>
</section>

<!-- Sección de Noticias -->
<section class="news-section">
    <div class="news-container">
        <div class="news-header">
            <div class="section-title-v10">
                <div class="title-subtitle">Gobierno de Nuevo Laredo</div>
                <h2>Noticias</h2>
            </div>
        </div>

        <div class="news-grid">
            <!-- Noticias 1-3 - Grandes -->
            <article class="news-card news-card-large" *ngFor="let item of noticiasBanner?.slice(0, 3)"
                (click)="irNoticia(item)">
                <div class="news-image" [style.background-image]="'url(' + item.archivo + ')'">
                    <div class="news-overlay"></div>
                    <div class="news-avatar">
                        <img src="https://nld.gob.mx/assets/logos/logonld.png" alt="Gobierno NLD">
                    </div>
                    <div class="news-content">
                        <span class="news-date">{{ item.fecha2 }}</span>
                        <h3 class="news-title">{{ item.titulo }}</h3>
                    </div>
                </div>
            </article>

            <!-- Noticias 4-11 - Medianas -->
            <article class="news-card" *ngFor="let item of noticiasBanner?.slice(3, 11)" (click)="irNoticia(item)">
                <div class="news-image" [style.background-image]="'url(' + item.archivo + ')'">
                    <div class="news-overlay"></div>
                    <div class="news-avatar">
                        <img src="https://nld.gob.mx/assets/logos/logonld.png" alt="Gobierno NLD" loading="lazy">
                    </div>
                    <div class="news-content">
                        <span class="news-date">{{ item.fecha2 }}</span>
                        <h3 class="news-title2">{{ item.titulo }}</h3>
                    </div>
                </div>
            </article>
        </div>
    </div>
</section>

<!-- Sección de Anuncios y Convocatorias -->
<!--
<section class="announcements-section-v1a">
    <div class="announcements-container">
     
        <div class="news-header">
            <div class="section-title-v10">
                <div class="title-subtitle">Lo más reciente</div>
                <h2>Anuncios y Actividades</h2>
            </div>
        </div>

        <div class="carousel-wrapper" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
       
        <div class="carousel-container">
            <div class="carousel-track" [style.transform]="'translateX(' + currentTranslate + '%)'">
                <div class="carousel-slide" *ngFor="let anuncio of anuncios">
                    <div class="announcement-card" (click)="abrirModal(anuncio)">
                        <img [src]="anuncio.imagen" [alt]="anuncio.titulo" class="announcement-image" loading="lazy">
        
                    
                        <div class="link-badge" *ngIf="anuncio.redireccionDirecta">
                            <i class="bi bi-box-arrow-up-right"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        

          
         
        </div>

       
      
    </div>
    <div class="announcements-container mt-3">
    
      
    
        <div class="carousel-wrapper" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
         
            <div class="carousel-container">
                <div class="carousel-track" [style.transform]="'translateX(' + currentTranslate + '%)'">
                    <div class="carousel-slide" *ngFor="let anuncio of anuncios2">
                        <div class="announcement-card" (click)="abrirModal(anuncio)">
                            <img [src]="anuncio.imagen" [alt]="anuncio.titulo" class="announcement-image" loading="lazy">
    
                           
                            <div class="link-badge" *ngIf="anuncio.redireccionDirecta">
                                <i class="bi bi-box-arrow-up-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
    
    
        </div>
    
      
    </div>
</section>
-->
<!-- Sección de Anuncios y Convocatorias -->
<section class="announcements-section-v1a">
    <div class="announcements-container">

        <div class="news-header">
            <div class="section-title-v10">
                <div class="title-subtitle">Lo más reciente</div>
                <h2>Anuncios y Actividades</h2>
            </div>
        </div>

        <!-- Grid de Anuncios (3 columnas x 2 filas) -->
        <div class="announcements-grid">
            <div class="announcement-card" *ngFor="let anuncio of anuncios" (click)="abrirModal(anuncio)">
                <img [src]="anuncio.imagen" [alt]="anuncio.titulo" class="announcement-image" loading="lazy">

                <!-- Icono de enlace externo para redirecciones directas -->
                <div class="link-badge" *ngIf="anuncio.redireccionDirecta">
                    <i class="bi bi-box-arrow-up-right"></i>
                </div>
            </div>
        </div>

    </div>
</section>
<!-- Modal de Anuncio -->
<!-- Modal - DEBE ESTAR DESPUÉS DE LA SECCIÓN DE ANUNCIOS -->
<div class="modal-overlay" *ngIf="modalVisible" (click)="cerrarModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">

        <!-- Botón cerrar -->
        <button class="modal-close" (click)="cerrarModal()">
            <i class="bi bi-x-lg"></i>
        </button>

        <!-- Contenido del modal -->
        <div *ngIf="anuncioSeleccionado">
            <img [src]="anuncioSeleccionado.imagen" [alt]="anuncioSeleccionado.titulo" class="modal-image">

            <h3 class="modal-title">{{ anuncioSeleccionado.titulo }}</h3>

            <p *ngIf="anuncioSeleccionado.descripcion" class="modal-description">
                {{ anuncioSeleccionado.descripcion }}
            </p>

            <!-- Botón solo si existe -->
            <a *ngIf="anuncioSeleccionado.botonTexto && anuncioSeleccionado.botonUrl"
                [href]="anuncioSeleccionado.botonUrl" [target]="anuncioSeleccionado.botonTarget" class="modal-button">
                {{ anuncioSeleccionado.botonTexto }}
            </a>
        </div>
    </div>
</div>
<!-- ============================================
     SECCIÓN 1: TRÁMITES MÁS COMUNES (PRINCIPAL)
     ============================================ -->
<section class="tramites-comunes-section" id="tramites-comunes2">
    <div class="tramites-comunes-container">
        <!-- Título -->
        <div class="section-title-v10">
            <div class="title-subtitle">ACCESO RÁPIDO</div>
            <h2>Trámites Más Comunes</h2>
        </div>

        <!-- Grid de Trámites -->
        <div class="tramites-comunes-grid">
            <a routerLink="/becas" target="_blank" class="tramite-comun-card">
                <div class="tramite-comun-icon">
                    <i class="bi bi-mortarboard"></i>
                </div>
                <h3 class="tramite-comun-title">Consulta el estatus de tu beca</h3>
                <div class="tramite-comun-arrow">
                    <i class="bi bi-arrow-right-circle-fill"></i>
                </div>
            </a>
            <a href="http://201.144.104.26/prepasnld/Ingresar.aspx" target="_blank" class="tramite-comun-card">
                <div class="tramite-comun-icon">
                    <i class="bi bi-mortarboard"></i>
                </div>
                <h3 class="tramite-comun-title">Pagos Prepas Municipales</h3>
                <div class="tramite-comun-arrow">
                    <i class="bi bi-arrow-right-circle-fill"></i>
                </div>
            </a>

            <a href="https://www.miregistrocivil.gob.mx/" target="_blank" class="tramite-comun-card">
                <div class="tramite-comun-icon">
                    <i class="bi bi-file-earmark-person"></i>
                </div>
                <h3 class="tramite-comun-title">Mi Registro Civil</h3>
                <div class="tramite-comun-arrow">
                    <i class="bi bi-arrow-right-circle-fill"></i>
                </div>
            </a>

            <a href="https://www.comapanuevolaredo.gob.mx/sitio/" target="_blank" class="tramite-comun-card">
                <div class="tramite-comun-icon">
                    <i class="bi bi-droplet"></i>
                </div>
                <h3 class="tramite-comun-title">COMAPA</h3>
                <div class="tramite-comun-arrow">
                    <i class="bi bi-arrow-right-circle-fill"></i>
                </div>
            </a>

            <a routerLink="/diga" class="tramite-comun-card">
                <div class="tramite-comun-icon">
                    <i class="bi bi-exclamation-triangle"></i>
                </div>
                <h3 class="tramite-comun-title">Quejas y Denuncias</h3>
                <div class="tramite-comun-arrow">
                    <i class="bi bi-arrow-right-circle-fill"></i>
                </div>
            </a>

            <a routerLink="/predial" class="tramite-comun-card">
                <div class="tramite-comun-icon">
                    <i class="bi bi-house"></i>
                </div>
                <h3 class="tramite-comun-title">Consulta y Pago Predial</h3>
                <div class="tramite-comun-arrow">
                    <i class="bi bi-arrow-right-circle-fill"></i>
                </div>
            </a>
            <!--
            <a href="https://www.gob.mx/curp/" target="_blank" class="tramite-comun-card">
                <div class="tramite-comun-icon">
                    <i class="bi bi-people"></i>
                </div>
                <h3 class="tramite-comun-title">CURP</h3>
                <div class="tramite-comun-arrow">
                    <i class="bi bi-arrow-right-circle-fill"></i>
                </div>
            </a>
        -->
            <a href="https://www.bolsadeempleo.com.mx/bolsadeempleo" target="_blank" class="tramite-comun-card">
                <div class="tramite-comun-icon">
                    <i class="bi bi-briefcase"></i>
                </div>
                <h3 class="tramite-comun-title">Bolsa de Empleo</h3>
                <div class="tramite-comun-arrow">
                    <i class="bi bi-arrow-right-circle-fill"></i>
                </div>
            </a>
            <a href="https://obraspublicas.nld.gob.mx/" target="_blank" class="tramite-comun-card">
                <div class="tramite-comun-icon">
                    <i class="bi bi-eye"></i>
                </div>
                <h3 class="tramite-comun-title">Avance de Obras Públicas</h3>
                <div class="tramite-comun-arrow">
                    <i class="bi bi-arrow-right-circle-fill"></i>
                </div>
            </a>
        </div>

        <!-- Botón Ver Más -->
       <div class="tramites-comunes-footer">
            <a href="http://201.144.104.26/nldretys/" target="_blank" class="btn-ver-mas-tramites">
                <span>Listado de todos los trámites y servicios</span>
                <i class="bi bi-arrow-right-circle"></i>
            </a>
        </div>
    </div>
</section>

<!-- ============================================
     SECCIÓN 2: ENLACES DESTACADOS (SECUNDARIA)
     ============================================ -->

<!-- Sección de Banner Horizontal -->
<section class="banner-section">
    <div class="banner-container">
        <a [href]="banner.url" [target]="banner.target || '_blank'" class="banner-link">
            <img [src]="banner.imagen" [alt]="banner.alt" class="banner-image" loading="lazy">
        </a>
    </div>
</section>

<!-- Modal para ver política completa -->
<div class="modal-overlay" *ngIf="modalPoliticaAbierto" (click)="cerrarPolitica()">
    <div class="modal-container" (click)="$event.stopPropagation()">
        <button class="modal-close" (click)="cerrarPolitica()">
            <i class="bi bi-x-lg"></i>
        </button>
        <div class="modal-content">
            <img [src]="politicaSeleccionada?.imagen" [alt]="politicaSeleccionada?.nombre" class="modal-image" loading="lazy">
        </div>
    </div>
</div>

<!-- Políticas Institucionales -->
<section class="politicas-section-v3">
    <div class="politicas-container">
        <!-- Título -->
        <div class="section-title-v10">
            <div class="title-subtitle">NUESTRO COMPROMISO</div>
            <h2>Gobierno Municipal</h2>
        </div>

        <div class="politicas-grid">
            <!-- Misión -->
            <div class="politica-card" (click)="abrirPolitica(politicaMision)">
                <div class="politica-card-image">
                    <img [src]="politicaMision.imagen" [alt]="politicaMision.nombre" loading="lazy">
                    <div class="politica-card-overlay"></div>
                </div>
                <div class="politica-card-content">
                    <div class="politica-card-icon">
                        <i class="bi bi-bullseye"></i>
                    </div>
                    <h3>Misión</h3>
                </div>
            </div>

            <!-- Visión -->
            <div class="politica-card" (click)="abrirPolitica(politicaVision)">
                <div class="politica-card-image">
                    <img [src]="politicaVision.imagen" [alt]="politicaVision.nombre" loading="lazy">
                    <div class="politica-card-overlay"></div>
                </div>
                <div class="politica-card-content">
                    <div class="politica-card-icon">
                        <i class="bi bi-eye"></i>
                    </div>
                    <h3>Visión</h3>
                </div>
            </div>

            <!-- Política de Calidad -->
            <div class="politica-card" (click)="abrirPolitica(politicaCalidad)">
                <div class="politica-card-image">
                    <img [src]="politicaCalidad.imagen" [alt]="politicaCalidad.nombre" loading="lazy">
                    <div class="politica-card-overlay"></div>
                </div>
                <div class="politica-card-content">
                    <div class="politica-card-icon">
                        <i class="bi bi-award"></i>
                    </div>
                    <h3>Política de Calidad</h3>
                </div>
            </div>

            <!-- Política Ambiental -->
            <div class="politica-card" (click)="abrirPolitica(politicaAmbiental)">
                <div class="politica-card-image">
                    <img [src]="politicaAmbiental.imagen" [alt]="politicaAmbiental.nombre" loading="lazy">
                    <div class="politica-card-overlay"></div>
                </div>
                <div class="politica-card-content">
                    <div class="politica-card-icon">
                        <i class="bi bi-tree"></i>
                    </div>
                    <h3>Política Ambiental</h3>
                </div>
            </div>

            <!--
            <div class="politica-card">
                <a [routerLink]="['varios']" [queryParams]="{id: 'organigrama'}" class="politica-card politica-card-link">
                <div class="politica-card-image">
                    <img [src]="politicaOrganigrama.imagen" [alt]="politicaOrganigrama.nombre">
                    <div class="politica-card-overlay"></div>
                </div>
                <div class="politica-card-content">
                    <div class="politica-card-icon">
                        <i class="bi bi-diagram-3"></i>
                    </div>
                    <h3>Organigrama</h3>
                </div>
                </a>
            </div>

          
            <a [routerLink]="['varios']" [queryParams]="{id: 'directorio'}" class="politica-card politica-card-link">
                <div class="politica-card-no-image">
                    <div class="politica-card-icon-large">
                        <i class="bi bi-person-lines-fill"></i>
                    </div>
                </div>
                <div class="politica-card-content">
                    <div class="politica-card-icon">
                        <i class="bi bi-person-lines-fill"></i>
                    </div>
                    <h3>Directorio</h3>
                    <span class="politica-card-arrow">
                        <i class="bi bi-arrow-right"></i>
                    </span>
                </div>
            </a>-->
        </div>
    </div>
</section>

<section class="enlaces-destacados-section">
    <div class="enlaces-destacados-container">
        <!-- Título discreto -->
        <h3 class="enlaces-title">Enlaces Destacados</h3>

        <!-- Lista compacta -->
        <div class="enlaces-lista">
            <a *ngFor="let enlace of otrosTramites" [href]="enlace.url" [target]="enlace.target || '_blank'"
                class="enlace-item">
                <div class="enlace-icon">
                    <i [class]="enlace.icono || 'bi bi-link-45deg'"></i>
                </div>
                <span class="enlace-nombre">{{ enlace.nombre }}</span>
                <i class="bi bi-chevron-right enlace-arrow"></i>
            </a>
        </div>
    </div>
</section>


<!-- Modal para ver política completa -->
<div class="modal-overlay" *ngIf="modalPoliticaAbierto" (click)="cerrarPolitica()">
    <div class="modal-container" (click)="$event.stopPropagation()">
        <button class="modal-close" (click)="cerrarPolitica()">
            <i class="bi bi-x-lg"></i>
        </button>
        <div class="modal-content">
            <img [src]="politicaSeleccionada?.imagen" [alt]="politicaSeleccionada?.nombre" class="modal-image" loading="lazy">
        </div>
    </div>
</div>

<section class="logos-section">
    <a href="https://www.gob.mx/" target="_blank" class="logo-box">
        <img src="https://nld.gob.mx/assets/img/gobmex.png" alt="Gobierno de México" loading="lazy">
    </a>
    <a href="https://www.plataformadetransparencia.org.mx/web/guest/inicio" class="logo-box">
        <img src="https://nld.gob.mx/assets/img/pndt.png" alt="Plataforma Nacional de Transparencia" loading="lazy">
    </a>
    <a href="https://www.tamaulipas.gob.mx/transparenciaparaelpueblodetamaulipas/" class="logo-box">
        <img src="https://transparencia.nld.gob.mx/assets/img/tam2.png" alt="Tamaulipas Transparencia" loading="lazy">
    </a>

    

    <a href="https://transparencia.gob.mx/home.html" class="logo-box">
        <img src="https://transparencia.nld.gob.mx/assets/img/buengob.png" alt="Buen Gobierno" loading="lazy">
    </a>

   
</section>